export const DISCOVERY_MODE_STEP_COMPLETED_MODAL = 'DISCOVERY_MODE_STEP_COMPLETED_MODAL';